import {AfterViewInit, Component, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ReplaySubject} from 'rxjs';
import {PartnerService} from '../../../shared/services/partner.service';
import {Partner} from '../../../shared/interface/partner';
import {HttpErrorResponse} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {delay, first, takeUntil} from 'rxjs/operators';
import {Ofwca} from '../../../shared/interface/ofwca';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {OfwcaAddDialogComponent} from '../../ofwcas/ofwca-add-dialog/ofwca-add-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {Contract} from '../../../shared/interface/contract';
import {ContractAddDialogComponent} from '../../contracts/contract-add-dialog/contract-add-dialog.component';
import {Document} from '../../../shared/interface/document';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {DocumentAddDialogComponent} from '../../documents/document-add-dialog/document-add-dialog.component';
import {FILE_TYPE_KRS_CEIDG,
  FILE_TYPE_PARTNER_DATA,
  FILE_TYPE_OVERCOMMISSION_AGREEMENT,
  FILE_TYPE_MANDATE_QUESTIONNAIRE} from '../../../shared/services/dict.service';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {OfwcaService} from '../../../shared/services/ofwca.service';
import {CountedAndPaginated} from '../../../shared/interface/response/counted-and-paginated';
import {Note} from "../../../shared/interface/note";
import {NoteAddDialogComponent} from "../../note/note-add-dialog/note-add-dialog.component";
import {AddLicensedComponent} from "../../agent-21/add-licensed/add-licensed.component";
import {AllLicensedAgentComponent} from "../../agent-21/all-licensed-agent/all-licensed-agent.component";
import {AffiliateCode} from "../../../shared/interface/affiliateCode";
import {
  ConfirmDialogWithReasonComponent,
  ConfirmResult
} from "../../../shared/components/confirm-dialog-with-reason/confirm-dialog-with-reason.component";
import {
  AffiliateCodeAddDialogComponent
} from "../../affiliate-code/affiliate-code-add-dialog/affiliate-code-add-dialog.component";

@Component({
  selector: 'app-show',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ShowComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(AllLicensedAgentComponent) allAgent21Component!: AllLicensedAgentComponent;

  readonly ACTIVE_VIEW = 'active_view';
  readonly ARCHIVE_VIEW = 'archive_view';
  readonly REGISTRATIONS_VIEW = 'registrations_view';

  partnerId: string;
  partner: ReplaySubject<Partner> = new ReplaySubject<Partner>(1);
  partnerObject?: Partner = null;
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;
  ofwcas: ReplaySubject<Ofwca[]> = new ReplaySubject<Ofwca[]>(1);
  contracts: ReplaySubject<Contract[]> = new ReplaySubject<Contract[]>(1);
  affiliateCode: ReplaySubject<AffiliateCode[]> = new ReplaySubject<AffiliateCode[]>(1);
  documents: ReplaySubject<Document[]> = new ReplaySubject<Document[]>(1);
  notes: ReplaySubject<Note[]> = new ReplaySubject<Note[]>(1);
  selectedTab: number;
  ofwcaViewControl: FormControl;
  ofwcaPartnerOff = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private partnerService: PartnerService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private auth: AuthService,
    private fb: FormBuilder,
    private ofwcaService: OfwcaService,
  ) {
    this.userPermissions = this.auth.getUserPermissions();
    this.ofwcaViewControl = fb.control(this.ACTIVE_VIEW);
  }

  ngOnInit(): void {
    this.route.params
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe(params => {
        if (params.id === undefined) {
          return;
        }
        this.partnerId = params.id;
        this.loadPartner();
        this.selectedTab = 0;
      });

    this.ofwcaViewControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.loadOfwcas())
    ;
    this.partnerService.get(this.partnerId)
      .subscribe((partner: Partner) => {
      this.partner.next(partner);
      this.partnerObject = partner;
    });
    this.partnerService.get(this.partnerId)
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe((partner: Partner) => {
        if (partner.ofwcaPartner === true){
          this.ofwcaPartnerOff = true;
        }else{
          this.ofwcaPartnerOff = false;
        }
      });
  }
  ngAfterViewInit(): void {}

  disableContract(event: boolean): void {
    this.ofwcaPartnerOff = event;
  }

  loadPartner(): void {
    this.partnerService.get(this.partnerId).subscribe((partner: Partner) => {
      this.partner.next(partner);
      this.partnerObject = partner;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych partnera', error.status.toString(), {
        duration: 2000
      });

      this.router.navigate(['/partnerzy']);
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
    if (e.tab.textLabel === 'OFWCA') {
      this.loadOfwcas();
    }

    if (e.tab.textLabel === 'Umowy') {
      this.loadContracts();
    }

    if (e.tab.textLabel === 'Dokumenty') {
      this.loadDocuments();
    }
    if (e.tab.textLabel === 'Notatki') {
      this.loadNotes();
    }

    if (e.tab.textLabel === 'Linki afiliacyjne') {
      this.loadAffiliateCode();
    }
  }

  loadOfwcas(): void {
    const response: ReplaySubject<CountedAndPaginated<Ofwca>> = new ReplaySubject<CountedAndPaginated<Ofwca>>(1);

    response
      .pipe(first())
      .subscribe((ofwcas: CountedAndPaginated<Ofwca>) => {
        this.ofwcas.next(ofwcas.items);
      });

    if (this.ofwcaViewControl.value === this.REGISTRATIONS_VIEW) {
      this.ofwcaService.loadList(0, 9999, {
        registrationPartner: this.partnerId,
      }, response, {
        sortBy: 'fullNameReversed',
        sortOrder: 'asc'
      });
    } else {
      this.ofwcaService.loadList(0, 9999, {
        partner: this.partnerId,
        archive: this.ofwcaViewControl.value === this.ARCHIVE_VIEW
      }, response, {
        sortBy: 'fullNameReversed',
        sortOrder: 'asc'
      });
    }
  }

  loadContracts(): void {
    this.partnerService.getPartnerContracts(this.partnerId)
      .subscribe((contracts: ListResponse<Contract>) => {
        this.contracts.next(contracts.items);
      });
  }

  loadAffiliateCode(): void {
    this.partnerService.getAffiliateCode(this.partnerId)
      .subscribe((affiliateCode: ListResponse<AffiliateCode>) => {
        this.affiliateCode.next(affiliateCode.items);
      });
  }

  loadNotes(): void {
    this.partnerService.getPartnerNotes(this.partnerId)
      .subscribe((note: ListResponse<Note>) => {
        this.notes.next(note.items);
      });
  }

  loadDocuments(): void {
    this.partnerService.getPartnerDocuments(this.partnerId)
      .subscribe((documents: ListResponse<Document>) => {
        this.documents.next(documents.items);
      });
  }

  addOfwca(): void {
    const dialogRef = this.dialog.open(OfwcaAddDialogComponent, {
      width: '90%',
      data: {partner: this.partnerObject},
      height: '90%',
      maxHeight: '90%',
      panelClass: 'full-height-dialog',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadOfwcas();
    });
  }

  addNote(): void {
    const dialogRef = this.dialog.open(NoteAddDialogComponent, {
      width: '90%',
      data: {partner: this.partnerObject},
      height: '90%',
      maxHeight: '90%',
      panelClass: 'full-height-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadNotes();
    });
  }

  addAgent21(): void {
    const dialogRef = this.dialog.open(AddLicensedComponent, {
      disableClose: true,
      data: {partnerObject: this.partnerObject},
      width: '90%',
      maxHeight: '90%',
      height: '670px',
      panelClass: 'full-height-dialog',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.allAgent21Component.refresh();
    });
  }

  addContract(): void {
    const dialogRef = this.dialog.open(ContractAddDialogComponent, {
      width: '55%',
      data: {partner: this.partnerObject},
      height: '570px',
      maxHeight: '90%',
      panelClass: 'full-height-dialog',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadContracts();
    });
  }

  addAffiliateCode(): void {
    const dialogRef = this.dialog.open(ContractAddDialogComponent, {
      width: '55%',
      data: {partner: this.partnerObject},
      height: '570px',
      maxHeight: '90%',
      panelClass: 'full-height-dialog',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadContracts();
    });
  }

  addDocument(): void {
    const dialogRef = this.dialog.open(DocumentAddDialogComponent, {
      width: '55%',
      data: {
        partnerObject: this.partnerObject,
        types: [FILE_TYPE_KRS_CEIDG, FILE_TYPE_PARTNER_DATA, FILE_TYPE_OVERCOMMISSION_AGREEMENT, FILE_TYPE_MANDATE_QUESTIONNAIRE],
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadDocuments();
    });
  }

  addAffiliateCod(): void {
    const dialogRef = this.dialog.open(AffiliateCodeAddDialogComponent, {
      width: '55%',
      data: {
        partnerObject: this.partnerObject,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadAffiliateCode();
    });
  }
}
